import { SpotFillRateMetricChart } from '@frontend/chart/components';
import { FormattedMessage } from 'react-intl';

import { StatisticsCard } from '../../shared';
import { useLast60DaysPudoSpotFillRateMetricChart } from './use-last-60-days-pudo-spot-fill-rate-metric-chart';

export interface Last60DaysPudoDailyFillRateMetricChartProps {
    accountId: string;
}

export const Last60DaysPudoDailyFillRateMetricChart = ({ accountId }: Last60DaysPudoDailyFillRateMetricChartProps) => {
    const { data, isLoading, hasData } = useLast60DaysPudoSpotFillRateMetricChart(accountId);

    return (
        <StatisticsCard
            chartKey={SpotFillRateMetricChart.definition.key}
            title={
                <FormattedMessage
                    id='platform.statistics.pudo.last-60-days-pudo-daily-fill-rate-metric-chart.title'
                    description='Title of the PuDo dashboard card showing average daily fill rate compared to last month'
                    defaultMessage='Daily occupancy'
                />
            }
            compact
            subtitle={
                <FormattedMessage
                    id='platform.statistics.pudo.last-60-days-pudo-timer-duration-metric-chart-card.subtitle'
                    description='Subtitle on PuDo dashboard cards comparing average drop-off or pick-up time to the previous month'
                    defaultMessage='Compared to last month'
                />
            }
            isLoading={isLoading}
            hasData={hasData}>
            {data && (
                <div className='mt-auto w-full'>
                    <SpotFillRateMetricChart data={data} />
                </div>
            )}
        </StatisticsCard>
    );
};
